import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectVersion } from '../redux/carDuck';
import { fetchVersions } from '../redux/apiDuck';
import { useHistory } from 'react-router-dom';
import ListItem from '../components/ListItem';
import List from '../components/List';
import Card from '../components/Card';
import Typography from '../components/Typography';
import Loader from '../components/Loader';

export const FourthStep = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { versions, fetching } = useSelector((state) => state.api);
  const { brandID, model, year } = useSelector((state) => state.car);

  useEffect(() => {
    dispatch(fetchVersions(brandID, model, year));
  }, [dispatch, brandID, model, year]);

  const handleSelectVersion = ({ version, codigoModelo, codigoSubModelo }) => {
    dispatch(selectVersion(version, codigoModelo, codigoSubModelo));

    // history.push('/gnc');
    history.push('/codigo-postal');
  };

  if (fetching) return <Loader />;

  return (
    <>
      <Typography text='¿Cúal es la versión de tu auto?' />
      <Card>
        <List>
          {versions.map((version) => (
            <ListItem
              key={version.version}
              text={version.version}
              handleClick={() => handleSelectVersion(version)}
            />
          ))}
        </List>
      </Card>
    </>
  );
};
